<template lang="pug">
  .part.part-7
    //- .game__cover
    //-   img(:src="author.cover" v-if="author")
    .game__richart
    .game__title(:class="`game__title--${count}`")
      p 你的心跳單曲製作中#[span .]#[span .]#[span .]
    .game__brand(:class="{'game__brand--show': isIframeLoaded}")
    iframe.game__canvas__iframe(
      src="./animation/brand/index.html",
      allowtransparency="true",
      scrolling="no",
      frameborder="0"
      :class="{'game__canvas__iframe--loaded': isIframeLoaded}"
      @load="iframeOnLoad"
    )
    //- button(v-if="mid" @click="get") 測試
    //- .game__canvas
    //- a.game__button.game__button--upload(href="#" @click.prevent="changePart(7)")
    //-   span 上傳你的單曲封面
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'

export default {
  name: 'GamePart7',
  mixins: [mixins],
  props: {
    changePart: Function,
  },
  data: () => {
    return {
      count: 0,
      timer: null,
      isIframeLoaded: false,
    }
  },
  computed: {
    ...mapState(['author'])
  },
  methods: {
    ...mapActions(['saveMid', 'saveSongData']),
    startTimer() {
      this.timer = setInterval(() => {
        this.count = (this.count + 1) % 4;
      }, 500)
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    upload() {
      const { author, saveMid, saveSongData, goToResultPage } = this;
      const { nickname, age, type, bpm, cover } = author;
      if (!nickname || !age || !type || !bpm) {
        this.$toast.error('缺少必要資訊，請重新整理頁面')
        return
      }
      axios
        .post('/api/Event/GetResult', {
          'NickName': nickname,
          'Age': age,
          'Tp': type,
          'Bpm': bpm,
          'ImgBase64': cover ? cover.split(',')[1] : '',
        })
        .then(resp => {
          if (this.isDev()) console.log(resp);
          const { rs, msg, code, item } = resp.data;
          if (code === 200 && rs === 'OK') {
            saveMid(msg);
            saveSongData(item);
            setTimeout(goToResultPage, 2500)
          } else {
            this.$toast.error(msg || '發生錯誤')
          }
        })
        .catch(() => {
          this.$toast.error('發生錯誤')
        })
    },
    iframeOnLoad() {
      this.isIframeLoaded = true;
    },
    goToResultPage() {
      this.$router.push('/result');
    },
  },
  mounted() {
    const { startTimer, upload } = this;
    startTimer();
    upload();
    // setTimeout(() => {
    //   this.goToResultPage();
    // }, 3000);
  },
  destroyed() {
    const { stopTimer } = this;
    stopTimer();
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-7/';

#game .part-7 {

  .game__richart {
    position: absolute;
    top: vw(355);
    left: vw(186);
    width: vw(393);
    height: vw(256);
    background: url($assets + 'richart.png') no-repeat 0 0 / vw(393) auto;
    animation: richart 1.5s steps(2) infinite;
  }

  @keyframes richart {
    to {background-position: 0 vw(-520);}
  }

  .game__cover {
    position: absolute;
    top: vw(312);
    left: vw(224);
    width: vw(302);
    height: vw(302);
    border-radius: vw(30);
    background: #000;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .game__title {
    position: absolute;
    top: vw(662);
    left: 0;
    width: 100%;
    z-index: 1;
    p {
      font-size: vw(36);
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(300, 36));
      padding-left: vw(50);
      @include narrow-text;
      @include neon-text;
    }
    span {
      opacity: 0;
    }
  }

  .game__title--1 span {
    &:nth-child(1) {opacity: 1;}
    &:nth-child(2) {opacity: 0;}
    &:nth-child(3) {opacity: 0;}
  }

  .game__title--2 span {
    &:nth-child(1) {opacity: 1;}
    &:nth-child(2) {opacity: 1;}
    &:nth-child(3) {opacity: 0;}
  }

  .game__title--3 span {
    &:nth-child(1) {opacity: 1;}
    &:nth-child(2) {opacity: 1;}
    &:nth-child(3) {opacity: 1;}
  }

  .game__brand {
    position: absolute;
    top: vw(823);
    left: vw(252);
    width: vw(242);
    height: vw(87);
    background: url($assets + 'brand.png') no-repeat 0 0 / contain;
    z-index: 1;
    opacity: 0;
    transition: opacity .5s ease .85s;
    &--show {
      opacity: 1;
    }
  }

  .game__canvas__iframe {
    position: absolute;
    top: vw(742);
    left: vw(146);
    width: vw(450);
    height: vw(246);
    visibility: hidden;
    opacity: 1;
    transform: scale(1.5);
    transition: opacity .5s ease 1s, transform 1.5s ease 0s;
    &--loaded {
      visibility: visible;
      opacity: 0;
      transform: scale(1);
    }
  }

}

</style>
